import React, { useEffect, useState } from 'react'
import ModalBasic from '../../components/infrastructure/Modals/ModalBasic'
import { authAxiosInstance } from '../../utils/axiosConfig'
import QueryString from 'qs';
import { useFormik } from 'formik';
import FormikTextareaGroup from '../../components/formik/FormikTextareaGroup';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import { toast } from 'react-toastify';

const EditComoplaintResolutionModal = ({
    editComoplaintResolutionModalOpen,
    setEditComoplaintResolutionModalOpen,
    complaintId,
    reFetchData = () => { }
}) => {
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            resolution: "",
        },
        onSubmit: async (values) => {
            console.log("values", values)
            try {
                const resp = await authAxiosInstance.patch(`/complaint`, {
                    _id: complaintId,
                    resolution: values.resolution
                })
                console.log("resp", resp)
                setEditComoplaintResolutionModalOpen(false);
                reFetchData()
                toast.success('Resolution updated successfully')
            } catch (error) {

            }
        }
    })
    const fetchComplaintData = async () => {
        try {
            const resp = await authAxiosInstance.get(`/complaint?${QueryString.stringify({
                _id: complaintId,
                populate: true
            })}`)
            console.log("resp", resp)
            formik.setFieldValue('resolution', resp?.data?.data?.docs?.[0]?.resolution)
        } catch (error) {
            console.log("error", error)
        }
    }
    useEffect(() => {
        if (!editComoplaintResolutionModalOpen) return;
        fetchComplaintData()
    }, [complaintId])
    return (
        <ModalBasic modalOpen={editComoplaintResolutionModalOpen} setModalOpen={setEditComoplaintResolutionModalOpen}>
            <div className='p-4'>
                <form action="" onSubmit={formik.handleSubmit}>
                    <div>
                        <FormikTextareaGroup
                            formik={formik}
                            label='Resolution'
                            name={'resolution'}
                        />
                    </div>
                    <div>
                        <PrimaryButton type='submit'>
                            Edit
                        </PrimaryButton>
                    </div>
                </form>
            </div>
        </ModalBasic>
    )
}

export default EditComoplaintResolutionModal
